import React from "react";

import { Box, Card } from "@chakra-ui/react";

import { Transaction } from "@/jenesys-types/jenesys-entities/config";
import { EntityRouteListIds } from "@/jenesys-types/list";

import { CrudList } from "@/components/common/crud/CrudList/CrudList";
import { CrudListFooter } from "@/components/common/crud/CrudList/CrudListFooter";
import { CrudListHeader } from "@/components/common/crud/CrudList/CrudListHeader";
import Barrier from "@/components/common/permission/Barrier";
import { EmptyState } from "@/components/features/settings/EmptyState";
import useNamedNavigate from "@/hooks/navigation/useNamedNavigate";
import { TransactionsListTable } from "@/routes/lazyFeatures";

export const TransactionsListRoute: React.FC = () => {
  const navigate = useNamedNavigate();
  return (
    <CrudList<Transaction>
      listId={EntityRouteListIds.Transactions}
      initialSortCriteria={{
        sortBy: "status_order",
        sortOrder: "ASC"
      }}
      baselineSorts={[
        { sortBy: "status_order", sortOrder: "ASC" },
        { sortBy: "date_of_invoice", sortOrder: "DESC" },
        { sortBy: "supplier_name", sortOrder: "ASC" }
      ]}
      localStorageConfig={{
        mechanism: "sessionStorage",
        keyPrefix: "TransactionsList",
        sortCriteria: true
      }}
    >
      <Barrier show when="document.read">
        <Box marginLeft={12} marginRight={12}>
          <CrudListHeader hideFilterBar={false} />
          <Card marginTop={4}>
            <TransactionsListTable />
            <CrudListFooter />
          </Card>
        </Box>
      </Barrier>

      <Barrier hide when="document.read">
        <EmptyState
          title="Upload a new document"
          ctaText="Upload document"
          ctaAction={() => navigate("transactions.upload")}
          description="When you upload a new document, it will appear here"
          mt={16}
        />
      </Barrier>
    </CrudList>
  );
};
